import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./store/store";
import ChunkErrorBoundary from './components/ChunkErrorBoundary';
import { initVersionCheck } from './utils/versionCheck';

// ── Disable Android WebView pull-to-refresh ──────────────────────────────────
// Strategy: Make the BODY the scroll container. Keep body.scrollTop >= 1
// so Android's SwipeRefreshLayout always sees canScrollVertically(-1) = true
// and never triggers pull-to-refresh.

// Tell native to disable if bridge exists
if (window.Android && typeof window.Android.disablePullToRefresh === 'function') {
  window.Android.disablePullToRefresh();
}

(function disablePullToRefresh() {
  // Make body scrollable and keep scrollTop at 1
  function initScroll() {
    document.body.style.overflow = 'auto';
    document.body.style.overscrollBehavior = 'none';
    document.body.style.height = 'auto';
    document.body.style.minHeight = '100vh';

    // Add 1px spacer at top of body so scrollTop=1 is always possible
    if (!document.getElementById('__ptr_spacer')) {
      const spacer = document.createElement('div');
      spacer.id = '__ptr_spacer';
      spacer.style.cssText = 'height:1px;width:100%;pointer-events:none;';
      document.body.insertBefore(spacer, document.body.firstChild);
    }

    // Scroll to 1px
    document.documentElement.scrollTop = 1;
    document.body.scrollTop = 1;
  }

  // Clamp scrollTop: if it reaches 0, bump to 1
  function onScroll() {
    const st = document.documentElement.scrollTop || document.body.scrollTop;
    if (st === 0) {
      document.documentElement.scrollTop = 1;
      document.body.scrollTop = 1;
    }
  }

  // Touch handler: block pull-down when at the very top
  let startY = 0;
  function onTouchStart(e) {
    startY = e.touches[0].clientY;
  }
  function onTouchMove(e) {
    const dy = e.touches[0].clientY - startY;
    if (dy <= 0) return; // scrolling up content, allow

    const st = document.documentElement.scrollTop || document.body.scrollTop;
    if (st <= 1) {
      e.preventDefault(); // at top and pulling down → block
    }
  }

  // Init on DOMContentLoaded and immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScroll);
  } else {
    initScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('touchstart', onTouchStart, { passive: true });
  document.addEventListener('touchmove', onTouchMove, { passive: false });
})();

// Initialize version check for deployment updates (auto hard refresh on new version)
initVersionCheck();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <ChunkErrorBoundary>
      <div className="appScaleWrapper">
        <App />
      </div>
    </ChunkErrorBoundary>
  </Provider>
);

reportWebVitals();
